export default __webpack_public_path__ + "static/media/YELP_MANUAL.72abb83e.png";